import { ZipcodeInput } from 'components/BaseInputs/ZipcodeInput';
import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';

const POSTALCODE_REGEX = /^\d{5}(-\d{4})?$/;

export const ConnectedZipcodeInput = React.forwardRef(
  ({ name, rules, required, id, ...props }, ref) => {
    return (
      <Controller
        name={name}
        rules={{
          required,
          pattern: {
            value: POSTALCODE_REGEX,
            message: 'Please enter a valid postal code',
          },
          ...rules,
        }}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { invalid, error },
        }) => (
          <ZipcodeInput
            id={id ?? name}
            fullWidth
            {...props}
            name={name}
            value={value || ''}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onBlur={onBlur}
            ref={ref}
            error={invalid}
            helperText={error?.message}
            required={Boolean(required || rules?.required)}
          />
        )}
      />
    );
  },
);

ConnectedZipcodeInput.displayName = 'ConnectedZipcodeInput';
ConnectedZipcodeInput.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
};
export default ConnectedZipcodeInput;
